import { Box, Grid, styled } from "@mui/material";
import {
  type FunctionComponent,
  type PropsWithChildren,
  useEffect,
} from "react";

import { SignInHero } from "Auth/Components/SignInHero";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Logo } from "Shared/Logo";

const Background = styled(Box)`
  height: 100vh;
  display: flex;
  alignItems: center;
  background: ${(props) => props.theme.palette.background.paper};
  padding: ${(props) => props.theme.spacing(Spacing.M)};
`;

type Props = { title: string };

export const UnauthenticatedLayout: FunctionComponent<
  PropsWithChildren<Props>
> = (props) => {
  const { title, children } = props;

  const { t } = useResource();

  useEffect(() => {
    document.title = `${title} | ${t(Resources.Common.AppName)}`;
  }, [title, t]);

  return (
    <Background>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container sx={{ height: "100%" }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <Box>
                <Logo size="md" />
              </Box>
              <Box
                sx={{
                  color: "white",
                  display: "flex",
                  flexGrow: 1,
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 24,
                }}
              >
                {children}
              </Box>
            </Box>
          </Grid>
          <Grid
            size={{ xs: 12, md: 6 }}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <SignInHero />
          </Grid>
        </Grid>
      </Box>
    </Background>
  );
};
